import { useTranslation } from "react-i18next";
import Title from "@/components/ui/Title/Title.tsx";
import Html from "@/components/ui/Html/Html.tsx";
import Loader from "@/components/ui/Loader/Loader.tsx";
import Button from "@/components/ui/Buttons/Button/Button.tsx";
import IconWand from "@/assets/icons/wand.svg?react";

type ComparisonProps = {
  text: string | null;
  loading: boolean;
  onOpenAdvice?: () => void;
}

const CLASS_PREFIX = `ws-widgets-comparison-conclusion`;

export const ComparisonConclusion = ({ text, loading, onOpenAdvice }: ComparisonProps) => {
  const { t } = useTranslation();

  if (!text && !loading && !onOpenAdvice) {
    return null;
  }

  return (
    <div className={ `${ CLASS_PREFIX }` }>
      <Title level={ 2 }>{ t(`comparison.conclusion.title`) }</Title>
      {
        loading ?
          <Loader horizontalAlign={ `left` }/>
          :
          null
      }
      {
        !loading && text ?
          <Html value={ text }/>
          :
          null
      }
      { onOpenAdvice &&
        <div className={ `${ CLASS_PREFIX }__advisor` }>
          <Title level={ 3 }>
            { t(`comparison.advice.advisor_title`) }
          </Title>
          <p>
            { t(`comparison.advice.advisor_intro`) }
          </p>
          <p>
            <Button variant={ `secondary` } className={ `${ CLASS_PREFIX }__advice-cta-button` } onClick={ onOpenAdvice }>
              <span className={ `${ CLASS_PREFIX }__advice-cta-icon` }>
                <IconWand/>
              </span>
              { t(`comparison.advice.title`) }
            </Button>
          </p>
        </div>
      }
    </div>
  )
}
